import { render } from "./MWalletSettings.vue?vue&type=template&id=d6530a1c&scoped=true"
import script from "./MWalletSettings.vue?vue&type=script&lang=js"
export * from "./MWalletSettings.vue?vue&type=script&lang=js"

import "./MWalletSettings.vue?vue&type=style&index=0&id=d6530a1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6530a1c"]])

export default __exports__